// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"129":"501b6b3f","506":"26428f5b","536":"18bdc276","682":"d48d2320","696":"4a69b650","785":"454bd0d3","949":"6622bea1","972":"c869d59b","976":"8c91fe22"}[chunkId] + ".chunk.js";
};